module.exports = __webpack_public_path__ + "img/1-3.12f881bb.png";